import { useFormattedTime } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/hooks/formats/useFormattedTime'
import { Time } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/types'
import { formatDay } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/utils/formats'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

export const useFormattedDateTime = (time: Time | null): string => {
    const { t } = useTranslation()

    const formattedTime = useFormattedTime(time)

    if (!time) return ''

    const isAsap = 'asap' in time

    return `${formatDay(isAsap ? dayjs().toISOString() : time.timed.start, t)} ${formattedTime.toLowerCase()}`
}
